<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.33333 9C6.17428 9 7.66667 10.5043 7.66667 12.36C7.66667 14.2157 6.17428 15.72 4.33333 15.72C2.49238 15.72 1 14.2157 1 12.36C1 10.5043 2.49238 9 4.33333 9ZM12.9996 9C14.8405 9 16.3329 10.5043 16.3329 12.36C16.3329 14.2157 14.8405 15.72 12.9996 15.72C11.1586 15.72 9.66625 14.2157 9.66625 12.36C9.66625 10.5043 11.1586 9 12.9996 9ZM24.9992 12.36C24.9992 10.5043 23.5068 9 21.6658 9C19.8249 9 18.3325 10.5043 18.3325 12.36C18.3325 14.2157 19.8249 15.72 21.6658 15.72C23.5068 15.72 24.9992 14.2157 24.9992 12.36Z" 
                :fill="color"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgMore',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>